import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from '@env/environment';
import { DataService } from "@serv/data.service";
import { firstValueFrom } from "rxjs";
import { ApiOSPost } from "@class/mkg-os";
import { RoService } from '@serv/ro.service';
import { authorizationTypes } from "@shared/lists/authorization-types";

@Injectable({
  providedIn: "root",
})
export class OsLlmService {
  url: string = `${environment.mkgoURL}/api/v1/os`;

  private _roService = inject(RoService);


  constructor(
    private _http: HttpClient,
    private _dataService: DataService) {
  }
  async add(data: ApiOSPost, isBudget: boolean = true) {
    const os = data;
    os['lastUpdate'] = new Date().toISOString();
    const header = await firstValueFrom(this._dataService.httpOptions(true));
    const response = await firstValueFrom(this._http.post<{ id: string }>(this.url, os, header));

    if (!isBudget) {
      const id_ro = response.id;
      const OS = await this._roService.get(id_ro);
      await this._roService.requestAuthorization(OS);
      await this._roService.authorize(OS, authorizationTypes.personally.id, { reason: "Abrindo OS diretamente" });
      await this._roService.makeAppointment(OS.id, new Date());
      await this._roService.open(OS, { reason: "Abrindo OS diretamente" });
    }
    return response;
  }





}
